import { TimePicker } from '@progress/kendo-react-dateinputs'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useRef } from 'react'
import { toast } from 'react-toastify'

export default function DropDownTimePicker(props) {
    const [time, settime] = useState(null)

    useEffect(() => {
        console.log(props)
        const { dataItem } = props
        var dataValue = checkForValidDate(new Date(dataItem[field]))
            ? new Date(dataItem[field])
            : ''
        settime(dataValue)
    }, [props])

    let onSetTime = (e) => {
        settime(e.target.value)
    }

    function isValidDate(d) {
        return d instanceof Date && !isNaN(d)
    }

    let setTimeOnBlur = (e) => {
        if (e.target.value !== undefined && e.target.value !== "") {
            if (props.onChange) {
                if (isValidDate(time)) {
                    props.onChange({
                        dataIndex: 0,
                        dataItem: props.dataItem,
                        field: props.field,
                        syntheticEvent: e,
                        value: new Date(time),
                    })
                } else {
                    props.onChange({
                        dataIndex: 0,
                        dataItem: {...props.dataItem, ETA_TM_XD: ""},
                        field: props.field,
                        syntheticEvent: e,
                        value: "",
                    })
                }
                
            }
        }
    }

    let checkForValidDate = (date) => {
        if (isNaN(date)) {
            // date object is not valid
            return false
        } else {
            // date object is valid
            return true
        }
    }

    let getTime = (dataValue) => {
        let hours = dayjs(dataValue).get('hour')
        let min = dayjs(dataValue).get('minute')
        let time = hours

        if (hours < 10) {
            time = ('0' + hours).slice(-2)
        }

        if (min < 10) {
            time = time + ':' + ('0' + min).slice(-2)
        } else {
            time = time + ':' + min
        }

        return time
    }

    const { dataItem } = props
    const field = props.field
    const dataValue = checkForValidDate(new Date(dataItem[field]))
        ? new Date(dataItem[field])
        : ''

    return (
        <td>
            {dataItem.inEdit ? (
                <TimePicker
                    onChange={(e) => {
                        onSetTime(e)
                    }}
                    onBlur={(e) => {
                        setTimeOnBlur(e)
                    }}
                    onSetTime={(e) => {
                        setTimeOnBlur(e)
                    }}
                    value={time}
                    format="HH:mm"
                />
            ) : dataValue !== '' ? (
                getTime(dataValue)
            ) : (
                ''
            )}
        </td>
    )
}
